import {
  ADD_CARDS_DATA,
  DELETE_CARD_DATA_BY_KEY,
  DELETE_CAROUSEL_IMAGE_BY_KEY,
  DELETE_LIST_IMAGE_BY_KEY,
  ADD_CARDS_DATA_DB,
  ORIGINAL_INDEX,
  ADD_ACTIONS,
  RESET_REDUX_STORE,
  ADD_ORIGINAL_INDEX,
  CHANGE_POSITION_ORIGINAL_INDEX,
  ADD_CAROUSEL_DATA,
  ADD_CAROUSEL_ACTION_CHOICES,
  ADD_APICARD_DATA,
  ADD_API_PARAM_DATA,
  DELETE_BUTTON,
  DELETE_BUTTON_CAROUSEL,
  DELETE_BUTTON_API_PARAM,
  UPDATE_ACTIONS,
  UPDATE_CAROUSEL_ACTIONS,
  UPDATE_API_PARAM_ACTIONS,
  UPDATE_API_TEMPLATE_ACTIONS,
  UPDATE_THUMBNAIL_INDEX,
  LEAVE_PAGE_TRUE,
  LEAVE_PAGE_FALSE,
} from '../types/conversationPreview';

export const leavePageTrue = () => {
  return {
    type: LEAVE_PAGE_TRUE,
    payload: true,
  };
};

export const leavePageFalse = () => {
  return {
    type: LEAVE_PAGE_FALSE,
    payload: false,
  };
};

export function addCardsData(stateKey, isLoading) {
  return {
    type: ADD_CARDS_DATA,
    payload: { stateKey, isLoading },
  };
}

export function deleteCardImage(stateKey, index, intent_id) {
  return {
    type: DELETE_CARD_DATA_BY_KEY,
    payload: { stateKey: stateKey, index: index, intent_id: intent_id },
  };
}
export function deleteCarouselCardImage(choice, stateKey, index, intent_id) {
  return {
    type: DELETE_CAROUSEL_IMAGE_BY_KEY,
    payload: {
      choice: choice,
      stateKey: stateKey,
      index: index,
      intent_id: intent_id,
    },
  };
}

export function deleteListCardData(Listindex, stateKey) {
  return {
    type: DELETE_LIST_IMAGE_BY_KEY,
    payload: { Listindex: Listindex, stateKey: stateKey },
  };
}
export function addCardsDataFromDb(data, intent_id) {
  return {
    type: ADD_CARDS_DATA_DB,
    payload: { data: data, intent_id: intent_id },
  };
}

export function addCurrentOriginalIndex(data) {
  return {
    type: ORIGINAL_INDEX,
    payload: data,
  };
}

export function addActions(data, originalIndex, intent_id) {
  return {
    type: ADD_ACTIONS,
    payload: { data, originalIndex, intent_id },
  };
}

export function resetReduxStore() {
  return {
    type: RESET_REDUX_STORE,
  };
}

export function addOriginalIndex(originalIndex, actionType, intent_id) {
  return {
    type: ADD_ORIGINAL_INDEX,
    payload: {
      originalIndex: originalIndex,
      actionType: actionType,
      intent_id: intent_id,
    },
  };
}

export function changePositioninOriginalIndArray(
  index,
  changedIndex,
  intent_id
) {
  return {
    type: CHANGE_POSITION_ORIGINAL_INDEX,
    payload: { index: index, changedIndex: changedIndex, intent_id: intent_id },
  };
}

export function addCarouselData(
  carousel_index,
  originalIndexCard,
  data,
  keyName,
  intent_id
) {
  return {
    type: ADD_CAROUSEL_DATA,
    payload: {
      carousel_index: carousel_index,
      originalIndexCard: originalIndexCard,
      data: data,
      keyName: keyName,
      intent_id: intent_id,
    },
  };
}

export function addCarouselActionChoices(
  data,
  originalIndex,
  carouselIndex,
  intent_id
) {
  return {
    type: ADD_CAROUSEL_ACTION_CHOICES,
    payload: { data, originalIndex, carouselIndex, intent_id },
  };
}

export function addAPICardData(
  API_index,
  originalIndex,
  data,
  keyName,
  intent_id
) {
  return {
    type: ADD_APICARD_DATA,
    payload: {
      API_index: API_index,
      originalIndex: originalIndex,
      data: data,
      keyName: keyName,
      intent_id: intent_id,
    },
  };
}

export function addAPIParamData(keyName, data, originalIndex, intent_id) {
  return {
    type: ADD_API_PARAM_DATA,
    payload: {
      keyName,
      data,
      originalIndex,
      intent_id,
    },
  };
}

export function deleteButton(key, button_index) {
  return {
    type: DELETE_BUTTON,
    payload: { key, button_index },
  };
}

export function deleteButtonCarousel(key, button_index, carousel_index) {
  return {
    type: DELETE_BUTTON_CAROUSEL,
    payload: { key, button_index, carousel_index },
  };
}

export function deleteButtonAPIParam(key, button_index) {
  return {
    type: DELETE_BUTTON_API_PARAM,
    payload: { key, button_index },
  };
}

export function updateActions(data, originalIndex, intent_id, buttonIndex) {
  return {
    type: UPDATE_ACTIONS,
    payload: { data, originalIndex, intent_id, buttonIndex },
  };
}

export function updateCarouselActionChoices(
  data,
  originalIndex,
  intent_id,
  buttonIndex,
  carousel_index
) {
  return {
    type: UPDATE_CAROUSEL_ACTIONS,
    payload: { data, originalIndex, intent_id, buttonIndex, carousel_index },
  };
}

export function updateAPIParam(data, originalIndex, intent_id, buttonIndex) {
  return {
    type: UPDATE_API_PARAM_ACTIONS,
    payload: { data, originalIndex, intent_id, buttonIndex },
  };
}

export function updateAPITemplateAction(
  data,
  originalIndex,
  intent_id,
  buttonIndex
) {
  return {
    type: UPDATE_API_TEMPLATE_ACTIONS,
    payload: { data, originalIndex, intent_id, buttonIndex },
  };
}

export function updateCarouselThumbnailInd(
  draggedInd,
  droppedInd,
  Intent,
  Index
) {
  return {
    type: UPDATE_THUMBNAIL_INDEX,
    payload: { draggedInd, droppedInd, Intent, Index },
  };
}
